import React, { useState } from "react";
import ApiCalling from "../../ApiServices/ApiCalling";

const UpdateMembershipService = () => {
  const [updatedMembData, setUpdatedMembData] = useState([]);
  const [couponData, setCouponData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [couponPopup, setCouponPopup] = useState(false);
  const itemsPerPage = 10;

  const getUpdatedMembership = async () => {
    try {
      setLoading(true);
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetMembershipType",
        data: null,
        headers: {
          session: sessionStorage.getItem("session"),
          sessionID: sessionStorage.getItem("sessionID"),
          userID: sessionStorage.getItem("userID"),
        },
      });

      if (res?.statuscode === 1) {
        setUpdatedMembData(res?.memberTypes);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getUpdatedMembership :", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCouponClick = async (id) => {
    try {
      setLoading(true);
      const bodyObject = { id: id };
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetAllCoupons",
        data: bodyObject,
        headers: {
          session: sessionStorage.getItem("session"),
          sessionID: sessionStorage.getItem("sessionID"),
          userID: sessionStorage.getItem("userID"),
        },
      });

      if (res?.statuscode === 1) {
        setCouponPopup(true);
        setCouponData(res);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getUpdatedMembership :", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    getUpdatedMembership,
    loading,
    updatedMembData,
    itemsPerPage,
    currentPage,
    setCurrentPage,
    handleCouponClick,
    couponData,
    couponPopup,
    setCouponPopup,
  };
};

export default UpdateMembershipService;
